const getTimeRemaining = (endtime) => {
  const t = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((t / 1000) % 60);
  const minutes = Math.floor(t / 1000 / 60);
  return {
    total: t,
    minutes,
    seconds,
  };
};

// use this logic for timer setting is chosen as clock time in the future
const getTimeElapsed = (startTime, totalMilliseconds) => {
  // Leave calculation as it is for easy understanding. startTime is set to hour
  const hourToMiliseconds = 60 * 60 * 1000;
  const minutesToMiliSeconds = 60 * 1000;
  const totalMillisecondsFromStart = totalMilliseconds + startTime * hourToMiliseconds;

  const hrs = Math.floor(totalMillisecondsFromStart / 1000 / 60 / 60);
  const minutes = Math.floor((totalMillisecondsFromStart - hrs * hourToMiliseconds) / 1000 / 60);
  const seconds = Math.floor(
    (totalMillisecondsFromStart - hrs * hourToMiliseconds - minutes * minutesToMiliSeconds) / 1000
  );

  return { hours: hrs % 24, minutes, seconds };
};

export default {
  namespaced: true,

  state: {
    minutes: 0,
    seconds: 0,
    timeinterval: null,
    total: 1,
    totalMilliseconds: 0,
    deadline: 0,
    timerClass: '',
    hour: 0,
    initialized: false,
    timeElapsed: 0,
  },

  actions: {
    initializeClock: ({ commit, state, rootState }) => {
      const { timer, versionConfig, timeElapsed } = rootState;
      const totalMilliseconds = (timer + timeElapsed) * 60 * 1000;
      state.deadline = new Date(
        Date.parse(new Date()) + totalMilliseconds - timeElapsed * 60 * 1000
      );
      state.totalMilliseconds = totalMilliseconds;
      state.timeElapsed = timeElapsed * 60 * 1000;
      // For inbox time management do something diferent, BUG-2928 and BUG-2922
      if (versionConfig && versionConfig.showTimerAsClock) {
        const startTime = +versionConfig.startTime;
        // Not sure if this check is for edge cases. Keeping this here just in case
        if (typeof versionConfig.startTime === 'number') {
          state.hour = Math.floor(startTime);
        }
        state.timeinterval = setInterval(
          () =>
            commit('updateClockTimeManagement', {
              endTime: state.deadline,
              startTime,
            }),
          1000
        );
      } else {
        state.timeinterval = setInterval(() => commit('updateClock', state.deadline), 1000);
      }
    },
  },

  mutations: {
    updateClock: (state, endtime) => {
      const t = getTimeRemaining(endtime);
      state.minutes = t.minutes;
      state.seconds = t.seconds;
      state.total = t.total;
      // count elapse time in ms
      state.timeElapsed += 1000;
    },

    updateClockTimeManagement: (state, { endTime, startTime }) => {
      const { total, seconds } = getTimeRemaining(endTime);

      if (total > 0) {
        // if game starts on half hour, start time will be 8.5 so we want to set minutes to 30 (can only start on hour or after 30 min)
        const additionalMinutes = startTime % 1 === 0 ? 0 : 30 * 60 * 1000;
        state.seconds = seconds;
        // Subtract totalMilliseconds from total to get time surpassed and count up instead of down
        state.minutes =
          Math.floor((state.totalMilliseconds + additionalMinutes - total) / (1000 * 60)) % 60;

        if (state.minutes % 60 === 0 && state.seconds === 59 && state.initialized) {
          state.hour = state.hour === 23 ? 0 : state.hour + 1;
        }
      } else {
        // if assessment completion time is past due but user should be able to see the clock ticking
        const { hours, minutes, seconds } = getTimeElapsed(startTime, state.totalMilliseconds);
        state.hour = hours;
        state.minutes = minutes;
        state.seconds = seconds;
        state.totalMilliseconds += 1000;
      }
      state.timeElapsed += 1000;
      state.total = total;
      if (!state.initialized) state.initialized = true;
    },

    UPDATE_DEADLINE: (state, timeImpact) => {
      if (timeImpact != 0) {
        state.timerClass = 'timeImpactEffect';
        state.deadline = new Date(Date.parse(state.deadline) + timeImpact * 1000);
        setTimeout(() => {
          state.timerClass = '';
        }, 2000);
      }
    },
  },

  getters: {
    elapsed: (state, getters, rootState) => {
      const isNoTimer =
        typeof rootState.simsettings?.assessment?.inboxTimeToComplete != 'undefined'
          ? rootState.simsettings.assessment?.inboxTimeToComplete === 'noTimer'
          : rootState.simsettings.exam?.data?.inboxTimeToComplete === 'noTimer';
      // const isNoTimer = rootState.simsettings.exam?.data?.inboxTimeToComplete === 'noTimer';

      //corner case: manually flip to version  set to no timer from gui
      const isManuallySetToNoTimer =
        rootState.simsettings?.allowReEntryInbox && rootState.versionConfig.hideTimer;

      if (isNoTimer || isManuallySetToNoTimer) {
        return state.timeElapsed;
      } else {
        if (state.total < 0) {
          return state.totalMilliseconds;
        }

        return state.total === 1 ? 0 : state.totalMilliseconds - state.total;
      }
    },
    currentTime: (state) => state.total,
    initialized: (state) => state.initialized,
    clockTimer: (state) => ({
      hour: state.hour,
      minutes: state.minutes,
    }),
  },
};
